import { Link } from 'react-router-dom';
import type { Issue, Status } from '../types';

/**
 * Список задач. Один и тот же и в очереди, и в общем списке: строка задачи не должна выглядеть
 * по-разному в зависимости от того, откуда на неё смотрят.
 */
export function IssueList({
  tenantId,
  issues,
  statusById,
  showQueueKey = false,
}: {
  tenantId: string;
  issues: Issue[];
  statusById: Map<string, Status>;
  /** В общем списке ключ уже содержит очередь, отдельная колонка не нужна. */
  showQueueKey?: boolean;
}) {
  return (
    <div className="issue-list">
      {issues.map((issue) => {
        const status = statusById.get(issue.statusId);
        return (
          <div className="issue-row" key={issue.id}>
            <Link className="key" to={`/t/${tenantId}/issues/${issue.key}`}>
              {issue.key}
            </Link>
            <Link className="summary" to={`/t/${tenantId}/issues/${issue.key}`}>
              {issue.summary}
            </Link>
            {status && (
              <span className={`badge ${STATUS_BADGE[status.category]}`}>{status.name}</span>
            )}
            <div className="issue-counters">
              {issue.counters.checklistTotal > 0 && (
                <span title="Чеклист">
                  {issue.counters.checklistDone}/{issue.counters.checklistTotal}
                </span>
              )}
              {issue.counters.comments > 0 && <span title="Комментарии">{issue.counters.comments} комм.</span>}
              {showQueueKey && <span>{issue.key.split('-')[0]}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}

/** Цвет несёт категория статуса, а не его название: названия тенант меняет как хочет. */
const STATUS_BADGE: Record<Status['category'], string> = {
  TODO: 'badge-gray',
  IN_PROGRESS: 'badge-blue',
  DONE: 'badge-green',
};